import React, { Component } from 'react';
import axios from 'axios';
import ToothComponent from '../../commons/Charting/ToothComponent';
import config from '../../../config';

let $   = window.$;

export default class ChartingModal extends Component {
    state = {
        isSaving: false,
        color: '',
        procedure: '',
        procedureId: 0,
        toothId: 'set-tooth',
        procedures: [],
        originalProcedures: [],
        toothData: [],
    };

    handleApplyProcedure = () => {
        let chartingToothNumbers = $('#chartingToothNumbers').val();

        this.props.onApplyTempToothData(chartingToothNumbers, this.props.chartType, this.props.addChartFill);

        this.clearForm();
        $('#setTooth').modal('hide');
    };

    handleCloseModal = () => {
        this.clearForm();
    };

    clearForm = () => {
        this.setState({
            toothData: [],
            clearTooth: true,
            color: '',
            procedure: '',
            procedureId: 0,
            procedures: this.state.originalProcedures
        });

        $('#filterText').val('');
        $('.procedureRB').attr('checked', false);

        let selectToothNumber = $('.selectToothNumber');

        selectToothNumber.val([]);
        selectToothNumber.select2('val', []);
    };

    successfullyMapped = (msg) => {
        // App.alert({
        //     container: '#charting-modal-container',
        //     place: 'append',
        //     type: 'success',
        //     message: msg,
        //     close: '1',
        //     reset: '1',
        //     focus: '1',
        //     closeInSeconds: '10',
        //     icon: 'check'
        // });
    };

    errorMapped = (msg) => {
        // App.alert({
        //     container: '#charting-modal-container',
        //     place: 'append',
        //     type: 'danger',
        //     message: msg,
        //     close: '1',
        //     reset: '1',
        //     focus: '1',
        //     closeInSeconds: '10',
        //     icon: 'warning'
        // });
    };

    handleRadioChange = (e) => {
        let color = e.target.dataset.color;
        let procedure = e.target.dataset.procedure;
        let procedureId = e.target.dataset.procedureid;

        this.setState({
            color,
            procedure,
            procedureId
        });
    };

    handleFilterProcedure = (e) => {
        if (e.target.value === '') {
            this.setState({
                procedures: this.state.originalProcedures
            });

            return false;
        }

        let procedures = this.state.originalProcedures.filter((value) => {
            let tmpVal = value.label.toLowerCase();
            let query = e.target.value.toLowerCase();

            return (tmpVal.indexOf(query) > -1);
        });

        this.setState({
            procedures
        });
    };

    getProcedures = () => {
        let url = `${config.apiUrl}management/dental/procedures`;

        axios.get(url).then((res) => {

            let procedures = [];

            res.data.data.forEach((item, i) => {
                let tmp = {
                    value: item.id,
                    label: item.procedure,
                    color: item.color,
                    category: item.category,
                    abbreviation: item.abbreviation
                };

                procedures.push(tmp);
            });

            this.setState({
                procedures,
                originalProcedures: procedures
            });
        });
    };

    componentWillMount() {
        this.getProcedures();
    }

    componentDidMount() {
        $.fn.select2.defaults.set("theme", "bootstrap");

        $('.selectToothNumber').select2({
            placeholder: 'Select Tooth Numbers',
            maximumInputLength : 2,
            width: null
        });

        $('#setTooth').on('show', () => {
            let oldDataIndex = this.props.charting.data.findIndex((item) => {
                // console.log(item.tooth_id + '==' + nextProps.toothNumber);
                // console.log(item.type + '==' + nextProps.chartType);
                // eslint-disable-next-line
                return item.tooth_id == this.props.toothNumber && item.type == this.props.chartType;
            });

            console.log(oldDataIndex);
            this.clearForm();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.toothNumber) {
            let selectedItems = $('.selectToothNumber').val();

            if (! selectedItems) {
                $('.selectToothNumber').select2('val', nextProps.toothNumber);
            } else {
                selectedItems.push(nextProps.toothNumber);
                $('.selectToothNumber').select2('val', selectedItems);
            }

            // $('.selectToothNumber').select2('val', nextProps.toothNumber);

            // eslint-disable-next-line
            if (this.props.toothNumber != nextProps.toothNumber) {
                let index = nextProps.charting.data.findIndex(item => {
                    // eslint-disable-next-line
                    return item.tooth_id == nextProps.toothNumber;
                });

                let chartingData = null;

                if (index >= 0) {
                    const {charting} = nextProps;
                    chartingData = charting.data[index];

                    let procedureIndex = this.state.procedures.findIndex(item => {
                        return item.abbreviation === chartingData.procedure_abbr;
                    });

                    if (procedureIndex >= 0) {
                        let procedure = this.state.procedures[procedureIndex];

                        this.setState({
                            color: procedure.color,
                            procedure: procedure.abbreviation,
                            procedureId: procedure.value
                        });

                        $('#' + procedure.abbreviation).prop('checked', true);
                    }
                }
            }

        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.toothNumber <= 0) {
            return false;
        }

        return true;
    }

    render() {
        return (
            <div id="setTooth" data-width="760" className="modal fade in"
                 tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">

                <div className="modal-content">
                    <div className="modal-header" style={{ borderBottom: 'none' }}>
                        <button type="button" className="close" onClick={this.handleCloseModal}
                                data-dismiss="modal" aria-hidden="true"/>
                    </div>
                    <div className="modal-body">

                        <div id="charting-modal-container" style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>

                        <div className="row">
                            <div className="col-md-6 col-lg-6 text-center">
                                <div id="toothComponent" style={{ width: '250px', margin: '20px auto' }}>
                                    <ToothComponent
                                        {...this.props}
                                        successCallback={this.successfullyMapped}
                                        errorCallback={this.errorMapped}
                                        color={this.state.color}
                                        procedure={this.state.procedure}
                                        procedureId={this.state.procedureId}
                                        toothId={this.state.toothId}
                                        toothData={this.state.toothData} />
                                </div>

                                <h3 style={{ color: '#adadad', fontWeight: '400' }}>Select the affected area</h3>
                            </div>

                            <div className="col-md-6 col-lg-6" style={{ borderLeft: '1px solid #dedede' }}>
                                <div className="procedureSelection">
                                    <h4>Procedure / Condition</h4>
                                    <div className="searchProcedure" style={{ marginBottom: '10px' }}>
                                        <input type="text" className="form-control"
                                               id="filterText"
                                               onChange={this.handleFilterProcedure}
                                               placeholder="Filter Procedure List"/>
                                    </div>

                                    <div id="procedureChoices" style={{ padding: '10px 20px' }}>
                                        {this.state.procedures.map((procedure, i) => {
                                            return (
                                                <div className="md-radio" key={i}>
                                                    <input type="radio" name="procedure" id={procedure.label}
                                                           className="md-radiobtn procedureRB" value={procedure.value}
                                                           data-color={procedure.color}
                                                           data-procedure={procedure.abbreviation}
                                                           data-procedureid={procedure.value}
                                                           onChange={this.handleRadioChange} />

                                                    <label htmlFor={procedure.label}>
                                                        <span/>
                                                        <span className="check"/>
                                                        <span className="box"/> {procedure.label}
                                                    </label>
                                                </div>
                                            )
                                        })}
                                    </div>

                                    <small>Select a specific procedure/condition</small>
                                </div>

                                <div className="applyToTooth" style={{ marginTop: '20px' }}>
                                    <select id="chartingToothNumbers" className="form-control selectToothNumber" multiple>
                                        <optgroup label="Adult">
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                            <option value="13">13</option>
                                            <option value="14">14</option>
                                            <option value="15">15</option>
                                            <option value="16">16</option>
                                            <option value="17">17</option>
                                            <option value="18">18</option>
                                            <option value="21">21</option>
                                            <option value="22">22</option>
                                            <option value="23">23</option>
                                            <option value="24">24</option>
                                            <option value="25">25</option>
                                            <option value="26">26</option>
                                            <option value="27">27</option>
                                            <option value="28">28</option>
                                            <option value="31">31</option>
                                            <option value="32">32</option>
                                            <option value="33">33</option>
                                            <option value="34">34</option>
                                            <option value="35">35</option>
                                            <option value="36">36</option>
                                            <option value="37">37</option>
                                            <option value="38">38</option>
                                            <option value="41">41</option>
                                            <option value="42">42</option>
                                            <option value="43">43</option>
                                            <option value="44">44</option>
                                            <option value="45">45</option>
                                            <option value="46">46</option>
                                            <option value="47">47</option>
                                            <option value="48">48</option>
                                        </optgroup>
                                        <optgroup label="Child">
                                            <option value="51">51</option>
                                            <option value="52">52</option>
                                            <option value="53">53</option>
                                            <option value="54">54</option>
                                            <option value="55">55</option>
                                            <option value="61">61</option>
                                            <option value="62">62</option>
                                            <option value="63">63</option>
                                            <option value="64">64</option>
                                            <option value="65">65</option>
                                            <option value="71">71</option>
                                            <option value="72">72</option>
                                            <option value="73">73</option>
                                            <option value="74">74</option>
                                            <option value="75">75</option>
                                            <option value="81">81</option>
                                            <option value="82">82</option>
                                            <option value="83">83</option>
                                            <option value="84">84</option>
                                            <option value="85">85</option>
                                        </optgroup>
                                    </select>

                                    <small>Enter the number of tooth to be applied</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    { this.state.isSaving ? (
                        <div className="modal-footer">
                            <button type="button" data-dismiss="modal" className="btn dark btn-outline" disabled>
                                Close
                            </button>
                            <button type="button" className="btn blue" disabled>
                                <i className="fa fa-spinner fa-spin" aria-hidden="true"/> &nbsp;
                                Saving
                            </button>
                        </div>
                    ) : (
                        <div className="modal-footer">
                            <button type="button" className="btn dark btn-outline" onClick={this.handleCloseModal}
                                    data-dismiss="modal">
                                Close
                            </button>
                            <button type="button" className="btn blue" onClick={this.handleApplyProcedure}>
                                Apply
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/charting/ChartingModal.js
 **/